<template>
    <div class="nrk">
        <Details  :data='data'/>
    </div>
</template>

<script>
 import{mapState} from'vuex';
export default {
    activated() {
        this.$store.dispatch('PostMemberInfo',{id:this.$route.query.id});
    },
    computed:{
        ...mapState({
            data:state=>state.share.MemberInfo,
        })
    },
}
</script>

<style>

</style>